import { styled } from '../../../theme/stitches.config';
import Container from '../../layout/Container';

export const StyledContainer = styled(Container, {
  '&.MuiContainer-root': {
    '@sm': {
      paddingLeft: 0,
      paddingRight: 0,
      paddgingTop: 0,
    },
    '@md': {
      paddingTop: 32,
    },
  },
});
